import React from 'react';
import { useQuery } from 'react-query';
import * as DOMPurify from 'dompurify';
import API from '@wheeebo/polaris-api';
import PlaceMarker from './PlaceMarker';
import { getWaypointTerminology, waypointActionLabel, waypointFieldLabels, waypointFieldVisibility } from '../../vehicle/vehicleTerms';
function WaypointMarker({ id, waypointId, position, ...props }) {
    const [content, setContent] = React.useState();
    const [open, setOpen] = React.useState(false);
    const options = { preload: ['flight_path', 'mission'] };
    const { data } = useQuery(API.Waypoints.getKey(waypointId, options), () => API.Waypoints.get(waypointId, options), {
        enabled: open,
    });
    const handleClick = React.useCallback(() => setOpen((e) => !e), []);
    React.useEffect(() => {
        DOMPurify.setConfig({ ALLOWED_TAGS: [] });
        const lat = typeof position?.lat === 'function' ? position.lat() : position?.lat || 0;
        const lng = typeof position?.lng === 'function' ? position.lng() : position?.lng || 0;
        const action = data?.action;
        const mode = getWaypointTerminology();
        const vis = waypointFieldVisibility(action, mode);
        const fieldLabels = waypointFieldLabels(mode);
        const pathLabel = mode === 'marine' ? 'Route' : 'Flight Path';
        const lines = [
            `<div style="padding-top: 0.25rem; padding-bottom: 0.25rem;">
        <span style="border-radius: 3px; border: 1px solid #888; padding: 0.15rem 0.75rem; font-size: 0.65rem">
        ${pathLabel}</span>
      </div>
      <h2 style="margin-top: 0.5rem; margin-bottom: 0.5rem">Waypoint #${data ? data.sequenceNumber + 1 : ''}</h2>
      <div style="white-space: pre">${`${lat.toFixed(6)}   ${lng.toFixed(6)}`}</div>
      <div style="padding-top: 1rem"><table>`,
        ];
        if (data?.flightPath?.mission) {
            lines.push(`<tr><td>Mission</td><td>${DOMPurify.sanitize(data?.flightPath?.mission?.name || '')}</td></tr>`);
        }
        if (data?.flightPath?.name) {
            lines.push(`<tr><td>${pathLabel}</td><td>${DOMPurify.sanitize(data?.flightPath?.name || '')}</td></tr>`);
        }
        lines.push(`<tr><td>Action</td><td>${DOMPurify.sanitize(waypointActionLabel(action, mode) || 'N/A')}</td></tr>`);
        if (vis.altitude) {
            lines.push(`<tr><td>${fieldLabels.altitude}</td><td>${data?.altitude || 'N/A'} m</td></tr>`);
        }
        if (vis.yaw) {
            lines.push(`<tr><td>${fieldLabels.yaw}</td><td>${data?.yaw || 'N/A'} \u00B0</td></tr>`);
        }
        if (vis.duration) {
            lines.push(`<tr><td>${fieldLabels.duration}</td><td>${data?.duration || 'N/A'} s</td></tr>`);
        }
        if (vis.speed) {
            lines.push(`<tr><td>${fieldLabels.speed}</td><td>${data?.speed || 'N/A'} m/s</td></tr>`);
        }
        lines.push('</table></div>');
        setContent(lines.join(''));
    }, [data, position]);
    return (React.createElement(PlaceMarker, { position: position, ...props, label: {
            text: id.toString(),
            color: 'white',
            fontWeight: 'bold',
        }, popupContent: content, onClick: handleClick }));
}
export default React.memo(WaypointMarker);
